import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Formik } from "formik";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import { IDividendIncome } from "../../../../config/interfaces";
import { DividendIncomesFormInitValues } from "../../../../pages/itr-filing/efiling.config";
import { useAppSelector } from "../../../../redux/Store";
import { ITRFilingSelector } from "../../../../redux/slice/ITRFilingSlice";
import FASvgIcon from "../../../FASvgIcon";
import ScrollToFirstError from "../../../ScrollToFirstError";
import OIAnyDividendFromDomesticCompForm from "../forms/OIAnyDividendFromDomesticCompForm";
import OIAnyDividendFromMutualFundsForm from "../forms/OIAnyDividendFromMutualFundsForm";

type Props = {
  showCanvas: boolean;
  formValues: IDividendIncome | null;
  handleCloseBtnPress: (salaryData: IDividendIncome | null) => void;
};

const OIDividendIncomeDetailsForm: React.FC<Props> = (props: Props) => {
  const { showCanvas, handleCloseBtnPress, formValues } = props;

  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  const [initFormValues, setInitFormValues] = useState<IDividendIncome>(
    DividendIncomesFormInitValues
  );

  useEffect(() => {
    if (showCanvas && formValues) {
      setInitFormValues(() => cloneDeep(formValues));
    } else {
      setInitFormValues(() => cloneDeep(DividendIncomesFormInitValues));
    }
  }, [showCanvas, formValues]);

  return (
    <>
      <Offcanvas show={showCanvas} placement="end" backdrop={true}>
        <Formik
          enableReinitialize={true}
          initialValues={initFormValues}
          onSubmit={(values) => handleCloseBtnPress(values)}
        >
          {({ handleSubmit, submitCount, isValid, errors }) => (
            <>
              <ScrollToFirstError submitCount={submitCount} isValid={isValid} errors={errors} />

              <Offcanvas.Header>
                <Offcanvas.Title>Dividend Income details</Offcanvas.Title>
                <Button
                  variant="primary"
                  className="icon-only hide-offcanvas"
                  onClick={() => handleCloseBtnPress(null)}
                >
                  <FASvgIcon icon={faXmark} />
                </Button>
              </Offcanvas.Header>

              <Offcanvas.Body>
                <OIAnyDividendFromDomesticCompForm />
                <OIAnyDividendFromMutualFundsForm />
              </Offcanvas.Body>

              <div className="offcanvas-btns">
                {!isFilingReadOnly ? (
                  <Button variant="outline-white" size="sm" onClick={() => handleSubmit()}>
                    Save and Close
                  </Button>
                ) : (
                  <Button
                    variant="outline-white"
                    size="sm"
                    onClick={() => handleCloseBtnPress(null)}
                  >
                    Close
                  </Button>
                )}
              </div>
            </>
          )}
        </Formik>
      </Offcanvas>
    </>
  );
};

export default OIDividendIncomeDetailsForm;
